import script from "./Mensalidades.vue?vue&type=script&lang=ts&setup=true"
export * from "./Mensalidades.vue?vue&type=script&lang=ts&setup=true"

import "./Mensalidades.vue?vue&type=style&index=0&id=5ef0a74c&lang=scss&scoped=true"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-5ef0a74c"]])

export default __exports__